import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
//impoertacion componentes

function CalificaFicha(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  const [postDescripcion, setPostDescripcion] = useState([]);

  const postData = (e) => {
    e.preventDefault(e);

    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/CrearRespuestasFicha",
      data: {
        solicitudId: props.idSolicitud,
        preguntaId: JSON.stringify(props.idPregunta),
        respuesta: "SI",
        origen: "Indicadores",
      },
    })
      .then((Response) => {
        console.log(Response.data);
        alert(Response.data);
      })
      .catch((error) => {
        console.log(error);
        alert("Error al Actualizar" + error);
      });
  };
  return (
    <div className="test">
      <center>
        <button className="btn btn-primary" onClick={postData}>
          SI
        </button>
      </center>
    </div>
  );
}
export default CalificaFicha;
